import Calculator from "./Calculator";
import TheTitle from "./TheTitle";

function App() {
    return(
    <section>
        <TheTitle />
        <Calculator />
    </section>)
}

export default App;
